export default settings => {
  return ({ default: provider }) => {
    return provider(settings);
  };
};
